module.exports = __webpack_public_path__ + "img/leftArrow.d83e4896.png";